import React, { useEffect, useState } from "react";
import { ListItemText, Grid, Divider } from "@mui/material";
import User from "../../types/User";
import UserAutocomplete from "../Shared/UserAutocomplete";
import Actions, { ActionProps } from "./Actions";
import SplitRow from "../Shared/SplitRow";
import { Lesson, LessonState } from "../../types/Lessons";
import { StateLabel, StateButton } from "./Buttons";
import { ChangeProps } from "./Show";
import Api from "../../network/Api";

const Toolbar = (props: ActionProps & ChangeProps) => {

  const usersSelectable = props.lesson && LessonState[props.lesson.state] === LessonState.draft;
  const [users, setUsers] = useState<Array<User>>([]);

  useEffect(() => {
    Api.get(`/users`).then(setUsers);
  }, []);

  return <>
    <Grid container spacing={2} alignItems="center">
    { props.lesson && <>
      <SplitRow label="State">
        <ListItemText sx={{margin: 0}}>{ StateLabel[props.lesson.state]?.toUpperCase() ?? String(props.lesson.state).toUpperCase() } { LessonState[props.lesson.state] !== LessonState.draft && <StateButton lesson={props.lesson} size="small" /> }</ListItemText>
      </SplitRow>

      { !usersSelectable ? <SplitRow label="Approver">
        <ListItemText sx={{margin: 0}}>{props.lesson.approver?.display_name}</ListItemText>
      </SplitRow> : <SplitRow label="Approver">
        <UserAutocomplete
          options={users ?? []}
          value={props.lesson.approver}
          placeholder="Add a responsible approver"
          onChange={user => {
            let newParam = { approver: user?.id ?? null }
            props.onChange(newParam);
            props.onSave(newParam);
          }}
        />
      </SplitRow> }

      <Grid size={12}>
        <Divider sx={{mb: 2}} />
        <Actions {...props} />
      </Grid>
      </> }
    </Grid>
  </>
}

export default Toolbar;